import { RoutingSelectors } from '../../../../selectors';
import { useSelector } from '../../../../selectors/useSelector';

import TwoBarChart from '../../../../components/Freemium/components/TwoBarChart';
import { useGetListingInquiries, useGetPremiumOverview } from '../../../../hooks/queries/freemium';

const PremiumStatistics = () => {
  const listingId = useSelector((state) => RoutingSelectors.makeListingId(state));
  const { data: premiumOverviewData } = useGetPremiumOverview({ listingId });

  const { data } = useGetListingInquiries(
    {
      listingId,
      beds: premiumOverviewData?.beds,
      propertyType: premiumOverviewData?.propertyType?.code,
    },
    {
      enabled: Boolean(premiumOverviewData),
    },
  );

  if (!data || !premiumOverviewData) {
    return null;
  }

  const getDomainMax = () => {
    const maxNum = Math.max(data.property.countSinceActivation, data.marketAverage.countSinceActivation);

    if (maxNum > 999) {
      return 1000;
    }
    if (maxNum > 99) {
      return 300;
    }

    return 100;
  };

  const inquiriesBarChartData = {
    chartData: [
      {
        name: 'Your inquiries',
        property: data.property.countSinceActivation,
      },
      {
        name: 'Average inquiries',
        average: data.marketAverage.countSinceActivation,
      },
    ],
    domainMax: getDomainMax(),
    width: 120,
    yAxisDataKey: 'name',
    topBarDataKey: 'average',
    bottomBarDataKey: 'property',
    bottomBarAdjustment: -13,
    topBarAdjustment: 4,
    tickColor: '#2A2A33',
    adjustmentText: 'Your inquiries',
  };

  // @ts-expect-error
  return <TwoBarChart data={inquiriesBarChartData} />;
};

export default PremiumStatistics;
